import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue';
import getSvgAsset from '@/assets/images/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  name: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

const images = getSvgAsset();


const isNeedShow = computed(() => !!images[props.name]);

return (_ctx: any,_cache: any) => {
  return (_unref(isNeedShow))
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(images)[__props.name]
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})